import React from 'react';
import {Link} from 'react-router-dom';
import DeleteIcon from 'material-ui-icons/Delete';
import ViewIcon from 'material-ui-icons/Visibility';
import {
    showDeleteRevisionButton,
    showApproveCheckboxes,
    showViewRevisionContentButton
} from '../../../components/permissions/permissions';
import {
    TableCell,
    TableRow,
    Tooltip,
    Radio,
    IconButton
} from 'material-ui';

class RevisionsTableContent extends React.Component {

    render() {
        const {
            classes,
            block,
            revision,
            approvedRevision,
            handleActive,
            handleClickOpen,
        } = this.props;

        const activeRadioApprove = () => (
            <Radio
                onChange={ev => handleActive(block.id, revision.id)}
                checked={checked}
            />
        )

        const disabledRadioApprove = () => (
            <Radio
                className={classes.disabledRadio}
                checked={checked}
            />
        )

        let ApproveBlockOrView = showApproveCheckboxes(activeRadioApprove, disabledRadioApprove);

        let ViewRevisionButton = showViewRevisionContentButton(() =>
            <span className={classes.tableIconBtn}>
                <Link to={"/blocks/" + block.id + "/view"}>
                    <Tooltip title="View block content for this revision">
                        <IconButton className="smallIconButton viewColor">
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                </Link>{' '}
            </span>
        )

        let DeleteRevisionButton = showDeleteRevisionButton(() =>
            <span className={classes.tableIconBtn}>
                <Tooltip title="Delete Revision">
                    <IconButton
                        className="smallIconButton deleteColor"
                        onClick={e => handleClickOpen(revision.id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            </span>
        )

        let checked = revision.id === approvedRevision;

        return (
                <TableRow hover={true}>
                    <TableCell className={classes.tableCell}>{revision.id}</TableCell>
                    <TableCell className={classes.tableCell}>{revision.revision}</TableCell>
                    <TableCell className={classes.tableCell}>
                        <ApproveBlockOrView />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Radio
                            className={classes.disabledRadio}
                            checked={!checked}
                        />
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <ViewRevisionButton />
                        <DeleteRevisionButton />
                    </TableCell>
                </TableRow>
            )
        }
    }

export default RevisionsTableContent;


// WEBPACK FOOTER //
// ./src/containers/blocks/revisions/RevisionsTableContent.jsx